import { Box, Text } from '@factorialco/deprecated-design-system'

import companies from 'modules/core/store/collections/companies'

import IncidenceDetailDataChangeLine from 'modules/bookkeepers/components/IncidenceDetailDataChangeLine'
import { getIncidenceDetailsLabel } from 'modules/payroll_bundle/lib/getIncidenceDetailsLabel'
import { FieldObject, IncidenceDetailsField } from 'modules/payroll_bundle/lib/types'

import { DetailProps, NewDetail, OldDetail, hasUpdate } from './helper'

interface Props {
  oldIncidenceDetail: OldDetail
  newIncidenceDetail: NewDetail
  contractFields: IncidenceDetailsField[]
  title: string
  legalEntityId?: number
}

const ContractDetails = ({
  oldIncidenceDetail,
  newIncidenceDetail,
  contractFields,
  title,
  legalEntityId,
}: Props) => {
  const company = companies.current

  const processed = (
    { field, extraField, valueModifier }: IncidenceDetailsField,
    incidenceDetail: DetailProps = newIncidenceDetail
  ) => {
    const fieldValues: FieldObject = {
      fieldValue: incidenceDetail[field],
      extraValue: incidenceDetail?.[extraField ?? ''],
      company,
      legalEntityId,
    }

    if (valueModifier) {
      return valueModifier(fieldValues)
    }

    return fieldValues.fieldValue as string
  }

  return (
    <Box gap="s8" paddingBottom="s24">
      <Text.Normal size="200" color="grey800" weight="bold">
        {title}
      </Text.Normal>
      <Box gap="s2" component="ul" paddingLeft="s16" style={{ listStyle: 'disc' }}>
        {contractFields.map(
          (basicField) =>
            hasUpdate(oldIncidenceDetail, newIncidenceDetail, basicField.field) && (
              <IncidenceDetailDataChangeLine
                key={basicField.field}
                label={getIncidenceDetailsLabel(basicField.translationKey ?? '')}
                oldValue={processed(basicField, oldIncidenceDetail)}
                newValue={processed(basicField) ?? null}
              />
            )
        )}
      </Box>
    </Box>
  )
}

export default ContractDetails
